/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {

    init: function() {
      const _this = this;

      $( '.introduction__filter-button' ).on( 'click', function() {
        const dept = $( this ).data( 'department' );

        $( this ).toggleClass( 'is-active' );

        if ( $( this ).hasClass( 'is-active' ) ) {
          $( '.introduction__filter-button' ).not( this ).removeClass( 'is-active' );
          $( '.introduction__card' ).addClass( 'hidden' );
          $( '.introduction__card[data-department="' + dept + '"]' ).removeClass( 'hidden' );
        } else {
          $( '.introduction__card' ).removeClass( 'hidden' );
        }
      } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'introduction', COMPONENT );
} )( app );


